(function () {

    'use strict';

	angular
		.module('app')
		.factory('SystemMessageService', SystemMessageService);

    function SystemMessageService($http, $q, $rootScope, WebAPIUrl) {

        var service = {
        	getMessages: getMessages,
        	getMessage: getMessage,
        	updateMessage: updateMessage,
            deleteMessage: deleteMessage
        };

        return service;

        function getMessages() {
        	var url = WebAPIUrl + "/api/SystemMessage/GetMessages";
	        return httpSend(url, "GET", false);
        }

		function getMessage(id) {
			var url = WebAPIUrl + "/api/SystemMessage/GetMessage?id=" + id.toString();
			return httpSend(url, "GET", false);
		}

		function updateMessage(msg) {
			var url = WebAPIUrl + "/api/SystemMessage/UpdateMessage?id=" + msg.SystemMessageId.toString();
			return httpSend(url, "POST", false, msg);
		}

		function deleteMessage(id) {
		    var url = WebAPIUrl + "/api/SystemMessage/DeleteMessage?id=" + id.toString();
		    return httpSend(url, "POST", false, id);
		}

		function httpSend(url, method, ignoreLoadingBar, data) {
			var deferred = $q.defer();

			$http({
				method: method,
				url: url,
				data: data,
				ignoreLoadingBar: ignoreLoadingBar
			}).success(function (data) {
				deferred.resolve(data);
			}).error(function (err, status) {
				deferred.reject(err, status);
			});

			return deferred.promise;
		}
    }
})();
